
const Q = require('q');

const Velocity = require('with-global-jquery')(function () {
	const Velocity = require('velocity-animate/velocity.js');
	Velocity.Promise = Q.Promise;
	require('velocity-animate/velocity.ui.js');
	return Velocity;
});

module.exports = Velocity;

